import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store';

export interface SupplierIdState {
    /** The current supplier-user supplierId if logged into a supplier account, 
        If logged into the admin account, this is the supplierId of the selected supplier-details supplier if one is selected. 
        Otherwise, this is the supplierId for the admin account. */
    viewAsSupplier: string;
}

const initialState: SupplierIdState = {
    viewAsSupplier: '',
};

export const viewAsSupplierSlice = createSlice({
    name: 'viewAsSupplier',
    initialState,
    reducers: {
        setViewAsSupplier: (state, action: PayloadAction<string>) => {
            state.viewAsSupplier = action.payload;
        },
    },
});

export const { setViewAsSupplier } = viewAsSupplierSlice.actions;
export const useViewAsSupplierSelector = (state: RootState) =>
    state.viewAsSupplier;
